import { IcoMoonSpan } from '@wwe-portal/ui/components/icons';
import { cn } from '@wwe-portal/ui/lib/lib';
import React, { ReactNode } from 'react';
import { ClickableDiv } from '../../../../../../../packages/ui/components/button';
import Link from 'next/link';

interface CalendarSelectItemProps {
  eventsDay: ReactNode;
  isActive: boolean;
  onClick: () => void;
  id: string;
  visible?: boolean;
  href?: string | null;
}

function CalendarSelectItem({
  eventsDay,
  isActive = false,
  id,
  onClick,
  href = null,
  visible = true,
}: Readonly<CalendarSelectItemProps>) {
  if (!visible) return null;
  return (
    <Link className="mb-[10px] grow pl-[5px] 2xl:px-5" href={`#${href || id}`}>
      <ClickableDiv onClick={onClick}>
        <div
          className={cn(
            'calendar__select__item flex w-full items-center justify-between rounded-[6px] pb-[10px] pl-[15px] pr-[10px] pt-[9px] transition duration-300 ease-linear md:pl-5 2xl:px-5',
            {
              calendar__select__item__active: isActive,
            }
          )}
          data-id={`${eventsDay}_calendar_select_item`}
        >
          <p className="mb-0 ml-2 text-sm capitalize">{eventsDay}</p>
          <IcoMoonSpan
            iconName="checkbox-rounded"
            className={cn('text-md text-text600 mr-2', {
              'text-green700': isActive,
            })}
          />
        </div>
      </ClickableDiv>
    </Link>
  );
}

export default CalendarSelectItem;
